import axios from "./axios";
import Vue from "vue";
import utils from "./utils"
import { createBLog } from "./log";
import common from "common";
import store from "../store/index.js";
import axiosConfig from "./axiosConfig";
const requestArr =["300183","300119","300176"]
const contentTypeJsonArr = ["300171","300173","300174","300176","900002","300178","300231"
  ,"300183", "300179","300177","300186", "300189", "300185","100001","100000","300130",
  "300200","300199","300201","300202","300203","300204","300205","300206","300230","300209",
"400025", "400026","400027","400028","400030", "400034","400035"];
export default function httpRequest({
  code,
  method = "post",
  data = {},
  params,
  success = function () {},
  fail = function () {},
  config = undefined
}) {
  if (config != undefined) {
    Object.assign(axiosConfig[code], config);
  }
  //正在请求不请求 进课与获取流地址接口正在请求不请求
  if (axiosConfig[code].isRequest && requestArr.includes(code)) {
    return;
  }
  if (!navigator.onLine) {
    fail();
    createBLog({
      id: "LMTrackEventAPI",
      data: {
        state: "0",
        apiID: code,
        url: common.API && common.API[code]
      }
    });
    return;
  }
  let url = "";
  let headers = {
    cook: common.getSession("COOK") || "",
  }
  const isHeaderVersion = common.get("isHeaderVersion") || [];
  if (!isHeaderVersion.includes(code * 1) && !isHeaderVersion.includes(code)) {
    headers.version = `${common.client};${common.version}`
  }
  let transformRequest = null;
  //图片上传type
  if (code === "300161") {
    headers['Content-Type'] = 'multipart/form-data'
  }
  if (contentTypeJsonArr.includes(code)) {
    headers['Content-Type'] = 'application/json';
    transformRequest = function (data) {
      if (typeof (data) === 'object') {
        return JSON.stringify(data);
      }
      return data;
    };
  }
  switch (code) {
    case "100000":
      if (common.get("showDebug") && common.get("configurl")) {
        url = common.get("configurl").url;
      } else {
        url = common.configurl.url;
      }
      break;
    case "100001":
      url = "https://api-config.zhuhuotech.com/config/envList";
      break;
    case "400012":
      url = common.API ? common.API[code] : 'https://api-live.zhuhuotech.com/misc/system-time';
      break;
    default:
      url = common.API && common.API[code];
  }
  if (!url) {
    throw Error(`code=${code},not url`)
  };
  axiosConfig[code].isRequest = true;
  axiosConfig[code].needLoading && Vue.prototype.$loading.showbg();
  // if (LIMI_ENV === "electron") {
  //   const u = new URL(url);
  //   let ips = await getIP(u.host);
  //   if (ips[0]) {
  //     url = url.replace(u.host, ips[0]);
  //     headers.dHost = u.host;
  //   }
  // }
  axios({
      url,
      transformRequest,
      method,
      needRepeat: axiosConfig[code].needRepeat,
      data,
      headers,
      params
    })
    .then(res => {
      axiosConfig[code].needLoading && Vue.prototype.$loading.close();
      axiosConfig[code].isRequest = false;
      try {
        if (res && res.data) {
          res.data.time && store.commit("upDateServerTime", res.data.time)
          if ((res.data.result == 1 && res.data.code == "E_SUCCESS") || res.data.code == 1000 || res.data.code == '000000' || (res.data.code == '10000' && code == "900002")) {
            // console.info("网络请求成功")
            success(res.data.data, true);
          } else {
            success(res.data, false);
            createBLog({
              id: "LMTrackEventAPI",
              data: {
                state: res.status,
                apiID: code,
                url: url
              }
            });
            if (res.data.code == "E_NOLOGIN" || res.data.code == "U1D102") {
              store.commit("httpErr", {
                type: 3,
                data: {
                  code,
                  method,
                  data,
                  params,
                  success,
                  fail
                }
              });
              return;
            }
            console.info("url:", url, "网络请求成功，业务失败");
            if (axiosConfig[code].alert) {
              //密码登录页密码错误不需要弹框
              const flag = (code !== '100105' && res.data.code != 2006 && res.data.code !== 'EXE111' && res.data.code !== 'EXE112')
              flag && store.commit("httpErr", {
                type: 1,
                data: {
                  code,
                  method,
                  data,
                  params,
                  success,
                  fail
                }
              });
              createBLog({
                id: "LMTrackEventTimeOutPop"
              });
            }
          }
        }
      } catch (er) {
        console.error(er);
      }
    })
    .catch(error => {
      let type = 1;
      if (error.message && error.message.indexOf("timeout") > -1) {
        type = 2;
      }
      if (axiosConfig[code].alert) {
        store.commit("httpErr", {
          type: type,
          data: {
            code,
            method,
            data,
            params,
            success,
            fail
          }
        });
        createBLog({
          id: "LMTrackEventTimeOutPop"
        });
      }
      createBLog({
        id: "LMTrackEventAPI",
        data: {
          state: (error.response && error.response.status) || "",
          apiID: code,
          url: url
        }
      });
      fail(error);
      console.warn("url:", url + "网络请求失败:", error);
      axiosConfig[code].needLoading && Vue.prototype.$loading.close();
      axiosConfig[code].isRequest = false;
    });
}
// let dominList = null;
// async function getIP(url) {
//   const HttpDnsCache = common.getSession("HttpDnsCache") || {};
//   if(HttpDnsCache[url] && HttpDnsCache[url].time > common.getTemServerTime()){
//     return [HttpDnsCache[url].ip]
//   }
//   if (!dominList && LIMI_ENV === "electron") {
//     dominList = utils.getNodeStorge("domainList")
//   }
//   try {
//     const res = await axios({
//       url: "http://203.107.1.33/116994/d",
//       method: 'get',
//       params: {
//         host: url
//       },
//       timeout: 1000
//     });
//     if (!res || !res.data || !res.data.ips || !res.data.ips.length) {
//       return dominList[url] ? [dominList[url]] : []
//     }
//     HttpDnsCache[url] = {
//       ip:res.data.ips[0],
//       time:common.getTemServerTime() + res.data.ttl
//     }
//     common.setSession("HttpDnsCache",HttpDnsCache)
//     return res.data.ips
//   } catch (error) {
//     return dominList[url] ? [dominList[url]] : []
//   }
// }



// WEBPACK FOOTER //
// ./src/js/httpUtils.js